export default __webpack_public_path__ + "static/media/HeroImg.77c04dc4.svg";